export const scenarioConstants = {
    CREATE_SCENARIO_REQUEST: 'CREATE_SCENARIO_REQUEST',
    CREATE_SCENARIO_SUCCESS: 'CREATE_SCENARIO_SUCCESS',
    CREATE_SCENARIO_FAILURE: 'CREATE_SCENARIO_FAILURE',

    GET_SCENARIO_REQUEST: 'GET_SCENARIO_REQUEST',
    GET_SCENARIO_SUCCESS: 'GET_SCENARIO_SUCCESS',
    GET_SCENARIO_FAILURE: 'GET_SCENARIO_FAILURE',

    UPDATE_SCENARIO_REQUEST: 'UPDATE_SCENARIO_REQUEST',
    UPDATE_SCENARIO_SUCCESS: 'UPDATE_SCENARIO_SUCCESS',
    UPDATE_SCENARIO_FAILURE: 'UPDATE_SCENARIO_FAILURE',

    GET_SCENARIOS_LIST_REQUEST: 'GET_SCENARIOS_LIST_REQUEST',
    GET_SCENARIOS_LIST_SUCCESS: 'GET_SCENARIOS_LIST_SUCCESS',
    GET_SCENARIOS_LIST_FAILURE: 'GET_SCENARIOS_LIST_FAILURE',

    SET_SCENARIOS_NULL_SUCCESS: 'SET_SCENARIOS_NULL_SUCCESS',

    COMPILE_CURRENT_SCENARIO_SUCCESS: 'COMPILE_CURRENT_SCENARIO_SUCCESS',
    COMPILE_CURRENT_SCENARIO_FAILURE: 'COMPILE_CURRENT_SCENARIO_FAILURE',

    OPEN_SCENARIO_REQUEST: 'OPEN_SCENARIO_REQUEST',
    OPEN_SCENARIO_SUCCESS: 'OPEN_SCENARIO_SUCCESS',
    OPEN_SCENARIO_FAILURE: 'OPEN_SCENARIO_FAILURE',

    CREATE_VALUES_REQUEST: 'CREATE_VALUES_REQUEST',
    CREATE_VALUES_SUCCESS: 'CREATE_VALUES_SUCCESS',
    CREATE_VALUES_FAILURE: 'CREATE_VALUES_FAILURE',

    CREATE_SCENARIO_VALUES_REQUEST: 'CREATE_SCENARIO_VALUES_REQUEST',
    CREATE_SCENARIO_VALUES_SUCCESS: 'CREATE_SCENARIO_VALUES_SUCCESS',
    CREATE_SCENARIO_VALUES_FAILURE: 'CREATE_SCENARIO_VALUES_FAILURE',

    CREATE_SCENARIO_REQUEST: 'CREATE_SCENARIO_REQUEST',
    CREATE_SCENARIO_SUCCESS: 'CREATE_SCENARIO_SUCCESS',
    CREATE_SCENARIO_FAILURE: 'CREATE_SCENARIO_FAILURE',

    DELETE_SCENARIO_REQUEST: 'DELETE_SCENARIO_REQUEST',
    DELETE_SCENARIO_SUCCESS: 'DELETE_SCENARIO_SUCCESS',
    DELETE_SCENARIO_FAILURE: 'DELETE_SCENARIO_FAILURE',

    UPDATE_VALUE_REQUEST: 'UPDATE_VALUE_REQUEST',
    UPDATE_VALUE_SUCCESS: 'UPDATE_VALUE_SUCCESS',
    UPDATE_VALUE_FAILURE: 'UPDATE_VALUE_FAILURE',

    UPDATE_VALUES_PERIODS_SUCCES: 'UPDATE_VALUES_PERIODS_SUCCESS',
    UPDATE_VALUES_PERIODS_FAILURE: 'UPDATE_VALUES_PERIODS_FAILURE',

    UPDATE_EFFECT_REQUEST: 'UPDATE_EFFECT_REQUEST',
    UPDATE_EFFECT_SUCCESS: 'UPDATE_EFFECT_SUCCESS',
    UPDATE_EFFECT_FAILURE: 'UPDATE_EFFECT_FAILURE',

    CALCULATE_CONVERGENCE_REQUEST: 'CALCULATE_CONVERGENCE_REQUEST',
    CALCULATE_CONVERGENCE_SUCCESS: 'CALCULATE_CONVERGENCE_SUCCESS',
    CALCULATE_CONVERGENCE_FAILURE: 'CALCULATE_CONVERGENCE_FAILURE',

    ASSEMBLE_BUSINESS_CASE_REQUEST: 'ASSEMBLE_BUSINESS_CASE_REQUEST',
    ASSEMBLE_BUSINESS_CASE_SUCCESS: 'ASSEMBLE_BUSINESS_CASE_SUCCESS',
    ASSEMBLE_BUSINESS_CASE_FAILURE: 'ASSEMBLE_BUSINESS_CASE_FAILURE',

    SET_CURRENT_SCENARIO_NULL_REQUEST: 'SET_CURRENT_SCENARIO_NULL_REQUEST',
    SET_CURRENT_SCENARIO_NULL_SUCCESS: 'SET_CURRENT_SCENARIO_NULL_SUCCESS',
    SET_CURRENT_SCENARIO_NULL_FAILURE: 'SET_CURRENT_SCENARIO_NULL_FAILURE',

    SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_REQUEST: 'SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_REQUEST',
    SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_SUCCESS: 'SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_SUCCESS',
    SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_FAILURE: 'SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_FAILURE',

    CREATE_CHANGE_IN_VALUES_REQUEST: 'CREATE_CHANGE_IN_VALUES_REQUEST',
    CREATE_CHANGE_IN_VALUES_SUCCESS: 'CREATE_CHANGE_IN_VALUES_SUCCESS',
    CREATE_CHANGE_IN_VALUES_FAILURE: 'CREATE_CHANGE_IN_VALUES_FAILURE',

    UPDATE_SCENARIO_CURRENCY_REQUEST: 'UPDATE_SCENARIO_CURRENCY_REQUEST',
    UPDATE_SCENARIO_CURRENCY_SUCCESS: 'UPDATE_SCENARIO_CURRENCY_SUCCESS',
    UPDATE_SCENARIO_CURRENCY_FAILURE: 'UPDATE_SCENARIO_CURRENCY_FAILURE',

    REORDER_SCENARIOS_REQUEST: 'REORDER_SCENARIOS_REQUEST',
    REORDER_SCENARIOS_SUCCESS: 'REORDER_SCENARIOS_SUCCESS',
    REORDER_SCENARIOS_FAILURE: 'REORDER_SCENARIOS_FAILURE',
};
